
export default function WhyUs() {
  const benefits = [
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Predictable Pricing',
      description: 'One flat monthly rate covers everything – no surprise charges or hidden fees',
      color: 'green',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Licensed & Insured',
      description: 'Fully certified professionals with comprehensive liability coverage',
      color: 'cyan',
    },
    {
      icon: 'ri-checkbox-multiple-line',
      title: 'Complete Coverage',
      description: 'For all landscape maintenance needs',
      color: 'yellow',
    },
    {
      icon: 'ri-24-hours-line',
      title: '24/7 Emergency Service',
      description: 'Round-the-clock response for urgent winter weather events',
      color: 'orange',
    },
    {
      icon: 'ri-star-smile-line',
      title: 'Satisfaction Guaranteed',
      description: 'We stand behind our work with a 100% satisfaction guarantee',
      color: 'emerald',
    },
    {
      icon: 'ri-calendar-event-line',
      title: 'Year-Round Service',
      description: 'From spring planting to winter snow removal – we do it all',
      color: 'sky',
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-yellow-50 text-yellow-700 rounded-full text-sm font-semibold mb-4">
            Why Choose Us
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">
            The Mow and Snow Advantage
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Experience the difference of working with the GTA's most trusted landscaping and snow removal company
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, idx) => (
            <div
              key={idx}
              className="group bg-gray-50 rounded-2xl p-8 hover:bg-white hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
            >
              <div
                className={`w-16 h-16 flex items-center justify-center rounded-xl mb-6 transition-transform group-hover:scale-110 ${
                  benefit.color === 'green'
                    ? 'bg-green-100'
                    : benefit.color === 'cyan'
                    ? 'bg-cyan-100'
                    : benefit.color === 'yellow'
                    ? 'bg-yellow-100'
                    : benefit.color === 'orange'
                    ? 'bg-orange-100'
                    : benefit.color === 'emerald'
                    ? 'bg-emerald-100'
                    : 'bg-sky-100'
                }`}
              >
                <i
                  className={`${benefit.icon} text-3xl ${
                    benefit.color === 'green'
                      ? 'text-green-600'
                      : benefit.color === 'cyan'
                      ? 'text-cyan-600'
                      : benefit.color === 'yellow'
                      ? 'text-yellow-600'
                      : benefit.color === 'orange'
                      ? 'text-orange-600'
                      : benefit.color === 'emerald'
                      ? 'text-emerald-600'
                      : 'text-sky-600'
                  }`}
                ></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{benefit.title}</h3>
              <p className="text-gray-600 leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
